import { includes } from 'lodash/fp'
import { Modal as StrapModal } from 'reactstrap'

class Modal extends React.Component {
  static defaultProps = {
    onEnter: () => {},
    onExit: () => {},
    toggle: () => {},
  }

  componentDidUpdate() {
    if (this.props.isOpen) {
      if (!includes('modal-open', document.body.className)) {
        document.body.classList.add('modal-open')
      }
    }
  }

  onEnter = () => {
    this.props.onEnter()
    document.addEventListener('backbutton', this.props.toggle)
  }

  onExit = () => {
    this.props.onExit()
    document.removeEventListener('backbutton', this.props.toggle)
  }

  render() {
    return <StrapModal {...this.props} onEnter={this.onEnter} onExit={this.onExit} />
  }
}

Modal.propTypes = StrapModal.propTypes

export default Modal
